(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/poy-table/assets/javascripts/poy-table.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/poy-table/assets/javascripts/poy-table.js');
"use strict";


const _svs$ui$reactTable = svs.ui.reactTable,
  Table = _svs$ui$reactTable.Table,
  TableHead = _svs$ui$reactTable.TableHead,
  TableRow = _svs$ui$reactTable.TableRow,
  TableHeader = _svs$ui$reactTable.TableHeader,
  TableBody = _svs$ui$reactTable.TableBody,
  TableCell = _svs$ui$reactTable.TableCell;
const formatCurrency = svs.utils.format.Currency;
const PoyTable = _ref => {
  let numberOfPlayers = _ref.numberOfPlayers,
    playerList = _ref.playerList,
    isCurrency = _ref.isCurrency,
    _ref$isNameSearch = _ref.isNameSearch,
    isNameSearch = _ref$isNameSearch === void 0 ? false : _ref$isNameSearch,
    searchString = _ref.searchString;
  const playerValue = value => {
    if (value && typeof value === 'number') {
      if (isCurrency) {
        return "".concat(formatCurrency(value), " kr");
      }
      return value;
    }
    return '-';
  };
  if (!playerList.length) {
    const noDataText = isNameSearch ? "Hittar inget som matchar din s\xF6kning \"".concat(searchString, "\"") : 'Hittar ingen rankinglista';
    return React.createElement("p", {
      className: "h3 f-content f-content-inverted"
    }, noDataText);
  }
  return React.createElement(Table, {
    "aria-labelledby": "poy-winners-header",
    className: "poy-table poy-table-standard f-content",
    large: true
  }, React.createElement(TableHead, null, React.createElement(TableRow, null, React.createElement(TableHeader, {
    scope: "col"
  }, "Position"), React.createElement(TableHeader, {
    scope: "col"
  }, "Deltagare", numberOfPlayers && typeof numberOfPlayers === 'number' && " (".concat(numberOfPlayers, " st)")), React.createElement(TableHeader, {
    scope: "col"
  }, isCurrency ? 'Vinst' : 'Poäng'))), React.createElement(TableBody, null, playerList.map(player => React.createElement(TableRow, {
    key: player.name
  }, React.createElement(TableCell, null, player.rankingPos), React.createElement(TableCell, null, player.name), React.createElement(TableCell, null, playerValue(player.value))))));
};
setGlobal('svs.poker_react.components.PoyTable', PoyTable);

 })(window);